import { parseDataTransform, uploadFile } from '@acme/common'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useAusenciasOutletContext } from 'pages/Ausencias'
import { SubmitHandler } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import {
    CreateFaltaCadastradaSchema,
    FaltaCadastrada,
    faltasCadastradas,
} from 'service/api/endpoints/faltas-cadastradas'
import { toast } from 'sonner'
import { useStore } from 'store'
import FormNovaFaltaCadastrada from 'templates/ManutencaoDoPonto/Digitacao/forms/NovaFaltaCadastrada'
import LancamentosAnteriores from '../lancamentos-anteriores'
import invalidateAusenciasQuery from './invalidateAusenciasQuery'

const baseUrl = import.meta.env.VITE_BASE_URL

export default function AdicionarFaltaCadastradaModal() {
    const location = useLocation()
    const { mutateAsync } = faltasCadastradas.mutations.useCreate({
        invalidateQuery: true,
    })

    const empresaId = useStore(state => state.companyId)
    const funcionarioId = useStore(state => state.employeeId)

    const { data } = useAusenciasOutletContext()
    const rows = data
        ?.filter(({ tipoAusencia }) =>
            ['Falta injustificada', 'Falta justificada'].includes(tipoAusencia),
        )
        ?.filter(item => item.funcionarioId == funcionarioId)

    const handleSubmit: SubmitHandler<
        FaltaCadastrada & { isInjustificada?: boolean }
    > = async ({ fileUrl, ...input }) => {
        if (input.isInjustificada) {
            delete input.justificativa
            fileUrl = null
        }

        const filename =
            (await uploadFile(fileUrl, baseUrl).catch(e => {
                toast.error(e.data?.message || e.message)
                return null
            })) || null
        await mutateAsync(
            {
                ...parseDataTransform(input),
                funcionarioId,
                empresaId,
                fileUrl: filename,
            },
            {
                onSuccess: async () => {
                    await invalidateAusenciasQuery()
                    toast.success('Falta cadastrada com sucesso!')
                },
                onError: e => {
                    toast.error(e.message)
                },
            },
        )
    }

    return (
        <Dialog.Root
            height="auto"
            width="50rem"
            onSubmit={handleSubmit}
            defaultValues={{
                isInjustificada: location.pathname.includes(
                    'falta-injustificada',
                ),
            }}
            schema={CreateFaltaCadastradaSchema}
            open={hasPermission([
                'create',
                'FaltasJustificadasOuInjustificadas',
            ])}
        >
            <Dialog.Title>Registrar falta</Dialog.Title>
            <Dialog.Content dividers>
                <FormNovaFaltaCadastrada />
                <LancamentosAnteriores rows={rows} />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
